import { Modal } from 'antd';
import DaumPostcode, { DaumPostcodeEmbedProps } from 'react-daum-postcode';

export interface ModalSearchAddressProps extends DaumPostcodeEmbedProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function AddressModal({ isOpen, onClose, ...props }: ModalSearchAddressProps) {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      bodyStyle={{
        paddingTop: '24px',
      }}
    >
      <DaumPostcode {...props} />
    </Modal>
  );
}
